// extracted by mini-css-extract-plugin
export default {"modal":"CashBoxModal_modal__ReEHM","container":"CashBoxModal_container__3wbzC","header":"CashBoxModal_header__GB+Jb","subtitle":"CashBoxModal_subtitle__Zw-Zi"};